import React, { useState } from 'react';
import { Button } from './ui/button';
import Header from './Header';
import Footer from './Footer';

const AdminPanel = () => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const seedProjects = async () => {
    setLoading(true);
    setMessage('');
    setError('');

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/seed-projects`, {
        method: 'POST',
      });

      const data = await response.json();

      if (response.ok) {
        setMessage(`✅ Erfolgreich! ${data.projects} Projekte wurden in der Datenbank aktualisiert.`);
      } else {
        setError(`❌ Fehler: ${data.detail || 'Unbekannter Fehler'}`);
      }
    } catch (err) {
      setError(`❌ Verbindungsfehler: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <div className="min-h-screen pt-32 pb-16 bg-gradient-to-b from-gray-50 to-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-2xl mx-auto">
            <h1 className="text-4xl font-bold text-gray-900 mb-4 text-center">
              Admin Panel
            </h1>
            <p className="text-gray-600 mb-8 text-center">
              Verwenden Sie diese Seite, um die Projektdaten in der Datenbank zu aktualisieren.
            </p>

            <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-200">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                Projekte aktualisieren
              </h2>
              <p className="text-gray-600 mb-6">
                Klicken Sie auf den Button unten, um alle 6 Waldschutzprojekte in der Datenbank zu aktualisieren.
                Dies muss nach jedem Deployment durchgeführt werden.
              </p>

              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
                <h3 className="font-semibold text-blue-900 mb-2">📋 Projekte die aktualisiert werden:</h3>
                <ul className="text-sm text-blue-800 space-y-1">
                  <li>• Schweiz (Alpen Region, 2'100 Hektar)</li>
                  <li>• Deutschland (Schwarzwald, 1'800 Hektar)</li>
                  <li>• Europa (3'500 Hektar)</li>
                  <li>• Afrika (4'100 Hektar)</li>
                  <li>• Südamerika (Amazon, 5'200 Hektar)</li>
                  <li>• Australien (Eukalyptus, 3'800 Hektar)</li>
                </ul>
              </div>

              <Button
                onClick={seedProjects}
                disabled={loading}
                className="w-full bg-[#FF1B8D] hover:bg-[#E01679] text-white py-6 rounded-full text-lg font-bold shadow-xl hover:shadow-2xl transition-all duration-300 disabled:opacity-50"
              >
                {loading ? 'Wird aktualisiert...' : 'Projekte jetzt aktualisieren'}
              </Button>

              {message && (
                <div className="mt-6 bg-green-50 border border-green-200 rounded-lg p-4">
                  <p className="text-green-800 font-semibold">{message}</p>
                  <p className="text-green-700 text-sm mt-2">
                    Die Projekte sind jetzt auf der Hauptseite sichtbar!
                  </p>
                </div>
              )}

              {error && (
                <div className="mt-6 bg-red-50 border border-red-200 rounded-lg p-4">
                  <p className="text-red-800 font-semibold">{error}</p>
                </div>
              )}
            </div>

            <div className="mt-8 text-center">
              <a href="/" className="text-[#FF1B8D] hover:text-[#E01679] font-semibold">
                ← Zurück zur Hauptseite
              </a>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AdminPanel;
